import './CartProductOverview.scss'

import React, {useEffect} from 'react'
import {Flipped} from 'react-flip-toolkit'
import {useFormContext} from 'react-hook-form'
import {useCart} from '../../../../util/cart'
import {useTranslation} from '../../../../util/i18n'
import {style} from '../../../../util/style'
import {Radios} from '../../../layout/Form'
import {Theme} from '../../../Theme'
import {OptionType} from '../../../ui/Dropdown'
import {MarkedTitle} from '../../../ui/MarkedTitle'
import {DeliveryType, ProductType, ProductVariationType} from '../../pages'
import {Price} from '../../ui/Price'
import {Calculator} from './Calculator'
import {CartProductContainer, CartProductFlipped} from './CartProduct'

const styles = style('cartproductoverview')

export const CartProductOverview: React.FC<{
	products: Array<ProductType>
	variations: Array<ProductVariationType>
	shippingcosts: Array<OptionType & {type: 'delivery' | 'takeaway'}>
	onConfirm: () => void
}> = ({products, variations, onConfirm, shippingcosts}) => {
	const {getValues, setValue, watch} = useFormContext()
	const {cart} = useCart()
	const cartProducts = cart.productsPerId
	const t = useTranslation('webshop').cart

	const watchShippingCosts = watch('shippingcosts')
	const selectedDelivery: DeliveryType = shippingcosts.find(
		(shipping: DeliveryType) => shipping.path === watchShippingCosts
	)
	useEffect(() => {
		setValue('shippingcosts', shippingcosts[0]?.path)
	}, [])

	const deliveryPrice = selectedDelivery?.price
	const deliveryFree = deliveryPrice === '0' || !deliveryPrice

	//double check if products exist in cms
	const existingCartProducts = cartProducts.filter((cartProduct) =>
		products.find((product) => cartProduct.productId === product.id.toString())
	)
	const hasExistingItems =
		existingCartProducts && existingCartProducts.length > 0
	return (
		<div className={styles}>
			<Theme.Container shifted="right">
				<MarkedTitle title={t.title} direction="left" />
				<div className={styles('content')}>
					{hasExistingItems && (
						<CartProductContainer>
							{existingCartProducts.map((product) => {
								const variants = product.variants
								const productDetails = products.find(
									(p) => p.id === Number(product.productId)
								)
								return (
									<CartProductFlipped
										key={product.productId}
										uniqueKey={product.productId}
										productVariants={variants}
										cartVariations={variations}
										{...productDetails}
									/>
								)
							})}
						</CartProductContainer>
					)}
					<Flipped flipId="shippingcosts">
						{hasExistingItems && (
							<div className={styles('content-shipping')}>
								<div className={styles('content-shipping-radios')}>
									<Radios options={shippingcosts} name={'shippingcosts'} />
								</div>
								<div className={styles('content-shipping-price')}>
									<Price>{deliveryFree ? t.free : `€ ${deliveryPrice}`}</Price>
								</div>
							</div>
						)}
					</Flipped>
					<Flipped flipId="calculator">
						{hasExistingItems && (
							<Calculator deliveryPrice={deliveryPrice} products={products} />
						)}
					</Flipped>
					<Flipped flipId="empty">
						{!hasExistingItems && (
							<div className={styles('empty')}>
								<Theme.H5>{t.empty}</Theme.H5>
							</div>
						)}
					</Flipped>
					{hasExistingItems && (
						<div className={styles('confirm')}>
							<Theme.Button onClick={onConfirm} mod={['minwidth']}>
								{t.order}
							</Theme.Button>
						</div>
					)}
				</div>
			</Theme.Container>
		</div>
	)
}
